import { z } from "zod";

export const PublicExpertLevelSchema = z.object({
    id: z.number().int(),
    public_title: z.string(),
    public_description: z.string().nullable(),
    commission_rate_bps: z.number().int(),
    auto_enroll_threshold_gross_cents: z.number().int(),
}).passthrough();

export const ExpertLevelSchema = PublicExpertLevelSchema.extend({
    internal_notes: z.string().nullable(),
    is_active: z.boolean(),
    sort_order: z.number().int(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    deleted_at: z.string().nullable().optional(),
}).passthrough();

export const CreateExpertLevelRequestSchema = z.object({
    public_title: z.string().min(1),
    public_description: z.string().nullable().optional(),
    internal_notes: z.string().nullable().optional(),
    auto_enroll_threshold_gross_cents: z.number().int().min(0),
    commission_rate_bps: z.number().int().min(0).max(10000),
    is_active: z.boolean().optional(),
    sort_order: z.number().int().min(0).optional(),
});

export const UpdateExpertLevelRequestSchema = CreateExpertLevelRequestSchema.partial();

export const AssignExpertLevelRequestSchema = z.object({
    expert_level_id: z.number().int(),
    notes: z.string().nullable().optional(),
});

export const CompactUserSchema = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    avatar: z.string().nullable(),
    email: z.string().nullable(),
}).passthrough();

export const ExpertLevelAssignmentSourceSchema = z.union([
    z.literal("auto"),
    z.literal("admin"),
]);

export const ExpertLevelAssignmentSchema = z.object({
    id: z.number().int(),
    expert_id: z.number().int(),
    expert_level_id: z.number().int().optional(),
    assigned_by_user_id: z.number().int().nullable().optional(),
    assignment_source: ExpertLevelAssignmentSourceSchema,
    notes: z.string().nullable(),
    assigned_at: z.string(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    level: ExpertLevelSchema,
    assigned_by_user: CompactUserSchema.nullable().optional(),
}).passthrough();

export type PublicExpertLevel = z.infer<typeof PublicExpertLevelSchema>;
export type ExpertLevel = z.infer<typeof ExpertLevelSchema>;
export type CreateExpertLevelRequest = z.infer<typeof CreateExpertLevelRequestSchema>;
export type UpdateExpertLevelRequest = z.infer<typeof UpdateExpertLevelRequestSchema>;
export type AssignExpertLevelRequest = z.infer<typeof AssignExpertLevelRequestSchema>;
export type CompactUser = z.infer<typeof CompactUserSchema>;
export type ExpertLevelAssignmentSource = z.infer<typeof ExpertLevelAssignmentSourceSchema>;
export type ExpertLevelAssignment = z.infer<typeof ExpertLevelAssignmentSchema>;
